import { z } from 'zod';

export const previewSearchParamName = 'dashboardId';

export const previewDashboardSearchSchema = z.object({
    [previewSearchParamName]: z.string().optional(),
});
